// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/party-popper.js';

import { paths } from '../generated/party-popper';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('party-popper', Original, paths);
